/** Sum of widths plus a gap between each adjacent pair. */
export const sumWithGaps = (widths: number[], gap: number): number => {
  if (widths.length === 0) return 0;
  const total = widths.reduce((accumulator, width) => accumulator + width, 0);
  return total + (widths.length - 1) * gap;
};
